/**
 * The `Rent_*` segment GAM keys off, both as the ad unit's listing-type child
 * (`/7449/HotPads/Search_Results/<here>/search_1`) and as the `listtp` targeting
 * key. Ported from legacy's `_getAdvertisementListingUrls` / `_getListtp`
 * (`srcLegacy/shared/modules/AdvertisementWrapper/helpers.ts`).
 */

import type { HpSearchFlag } from '@zg-rentals/ts-hotpads-api-client';

type SearchFlag = `${HpSearchFlag}`;

export const GENERAL_AD_LISTING_TYPE = 'Rent_General';

// Mirrors legacy's LISTING_DICT for the rental-type flags V3 carries in `mustHave`.
const AD_LISTING_TYPE_BY_FLAG: Partial<Record<SearchFlag, string>> = {
  standardRental: 'Rent_Rental',
  roomForRent: 'Rent_Roommate',
  sublet: 'Rent_Sublet',
  corporateHousing: 'Rent_Corporate',
};

/**
 * Narrowing the search to exactly one rental type moves it onto that type's ad
 * unit — that's how the `Rent_Roommate` inventory behind /rooms-for-rent gets
 * requested at all. No rental-type flag means every type is in scope (legacy's
 * default filter has all four enabled), which resolves to `Rent_General` just
 * like selecting more than one.
 */
export function getAdListingType(mustHave: ReadonlyArray<string> | undefined): string {
  const listingTypes = (mustHave ?? []).filter((flag): flag is SearchFlag => flag in AD_LISTING_TYPE_BY_FLAG);

  if (listingTypes.length !== 1) return GENERAL_AD_LISTING_TYPE;
  return AD_LISTING_TYPE_BY_FLAG[listingTypes[0]] ?? GENERAL_AD_LISTING_TYPE;
}
